var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"24px"}},[_c('proton-module',{key:_vm.proton,attrs:{"auths":_vm.auth,"proton":_vm.proton},on:{"recharge-succeed":_vm.rechargeSucceed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }